import { SET_CLIENT_PROGRAM } from "../actions/action-types.js";

export default function clientProgram(state = {}, {type, payload}) {
    switch (type) {
        case SET_CLIENT_PROGRAM:
            return (state = payload)
        default:
            return state
    }
}